export const SIZES = {
  NONE: 'None',
  SMALL: 'Small',
  MEDIUM: 'Medium',
  LARGE: 'Large',
  XLARGE: 'XLarge',
} as const

type SizesType = typeof SIZES
type SizesKeys = keyof SizesType
export type PaddingSize = SizesType[SizesKeys]

interface PaddingConfig {
  top?: PaddingSize
  bottom?: PaddingSize
  left?: PaddingSize
  right?: PaddingSize
  vertical?: PaddingSize
  horizontal?: PaddingSize
}

export type Padding = PaddingConfig | PaddingSize
